import getAllTableViewsContainingItems from '../../utils/getAllTableViewsContainingItems';
import { listViewStore } from 'owa-mail-list-store';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import getTableConversationRelation from 'owa-mail-list-store/lib/utils/getTableConversationRelation';
import mailStore from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';
import { shouldUpdateFolderCount } from 'owa-mail-list-actions';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
/**
 * Update the conversation relation unread count and the conversationItem's global unread count
 * @param conversationId the conversation id
 * @param tableViewId the table view id
 * @param shouldMarkAsRead the isRead value to set
 * @param conversationItems the item cache in mail store
 */
function rollUpUnreadCountChangeOnConversation(conversationId, tableView, shouldMarkAsRead, conversationItems) {
    // Get all the rowKeys for the given conversation and update the unread count all the relations
    var rowKeys = getRowKeysFromRowIds([conversationId], tableView);
    var tableViewId = tableView.id;
    rowKeys.forEach(function (rowKey) {
        var tableConversationRelation = getTableConversationRelation(rowKey, tableViewId);
        var conversationItem = conversationItems.get(conversationId);
        if (!tableConversationRelation) {
            // Early return if table doesn't have the conversation relation
            return;
        }
        if (shouldMarkAsRead) {
            tableConversationRelation.unreadCount--;
            conversationItem.globalUnreadCount--;
        }
        else {
            tableConversationRelation.unreadCount++;
            conversationItem.globalUnreadCount++;
        }
    });
}
/**
 * Mark the item read in list view store
 * @param itemIds the item ids to be marked as read/unread
 * @param shouldMarkAsRead the isRead value to set
 * @param state the MarkItemsReadInListViewStoreState
 */
export default action('MarkItemsReadInListViewStore')(select({
    items: function () { return mailStore.items; },
    conversationItems: function () { return listViewStore.conversationItems; },
})(function markItemsReadInListViewStore(itemIds, shouldMarkAsRead, state) {
    var selectedTableView = getSelectedTableView();
    var unreadCountChange = shouldMarkAsRead ? -1 * itemIds.length : itemIds.length;
    var folderId = selectedTableView.tableQuery.folderId;
    // If folder is under archive mailbox or shared folder, update unread/total count in folderstore
    shouldUpdateFolderCount(folderId) &&
        updateFolderCounts(unreadCountChange, 0, // total count
        folderId, true);
    itemIds.forEach(function (itemId) {
        var item = state.items.get(itemId);
        // Proceed the logic if item is present in item cache, because it might be removed from by notification
        if (item) {
            var conversationId_1 = item.ConversationId.Id;
            var tableViewsForItem = getAllTableViewsContainingItems(item.MailboxInfo, item.ParentFolderId.Id, true /* shouldIncludeSearchTable */);
            // Update the conversation relation in all tables of the corresponding folder
            tableViewsForItem.forEach(function (tableView) {
                return rollUpUnreadCountChangeOnConversation(conversationId_1, tableView, shouldMarkAsRead, state.conversationItems);
            });
        }
    });
}));
//# sourceMappingURL=markItemsReadInListViewStore.js.map